var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var l0 = _vm.store_open
    ? _vm.__map(_vm.storeData, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g0 = _vm.storeData.length
        return {
          $orig: $orig,
          g0: g0,
        }
      })
    : null
  var g1 = _vm.store_open ? _vm.storeData.length == 0 && !_vm.isloadding : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        l0: l0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }